import { IconShoppingCart, IconSearch, IconUser, IconHeart } from '@tabler/icons';

export const items = {
  user: {
    label: 'Sign in',
    icon: IconUser,
    href: '/log-in',
  },
  cart: {
    label: 'Cart',
    icon: IconShoppingCart,
    href: '/cart',
  },
}